// eslint-disable-next-line max-classes-per-file
import { TransformPlainObject } from './transform.plainObject';

export class AlterRowPlainObject extends TransformPlainObject {
    public conditions: IfCondtionPlainObject[] = [];
}

export class IfCondtionPlainObject {
    public conditionType: string;
    public expression: string;
}
